import { isType } from '../../helpers'
import Rule from './Rule'

export default class Str extends Rule {
  get ruleName () {
    return 'str'
  }

  passes () {
    return isType(this.value, 'string')
  }
}
